var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTutorialMacrosIcon = function SvgTutorialMacrosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu/ Macros")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu/-Macros",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(3.000000, 3.000000)",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0.5 16 0.5 11.6764636 5.87267415 8.62932742 5.87267415 2.18521746 9.5 0 9.5 10.8956666"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "21.5 16 12.5 10.8956666 12.5 0 16.1275695 2.18521746 16.1275695 8.62932742 21.5 11.6764636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    points: "17.0253231 21.3938432 10.9171126 18.0317729 4.9244224 21.5 1 19.2113657 10.8681634 13.5 21 19.0755378"
  })))));
};

export default __webpack_public_path__ + "static/media/tutorial-macros-icon.c5948b51.svg";
export { SvgTutorialMacrosIcon as ReactComponent };